import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

import { useNavigation } from '../../../common/navigation';
import { ExamSearch } from '../../components/Exam/ExamSearch';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { useCookies } from '../../../common/hooks/useCookies';
import { useAuth } from '../../../common/hooks/useAuth';
import { Role } from '../../../common/spdCore/authorization/roles';

interface ExamSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
}

export const ExamsActiveView: React.FC<ExamSearchProps> = props => {
  const nav = useNavigation();
  const cookies = useCookies();
  const auth = useAuth();

  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    if (cookies.activeTabMonitor === 'activeExams') {
      const interval = setInterval(() => setRefresh(prev => !prev), 30000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [cookies.activeTabMonitor]);

  return (
    <>
      <ExamSearch
        getData={props.getData}
        getCount={props.getCount}
        onRowClick={props.onRowClick}
        refresh={refresh}
        initialOrderColumn="exams.startDate"
        initialOrderDirection="DESC"
      />
      {auth.check([
        Role.PsychologistAssessor,
        Role.PsychologistSpecialist,
        Role.MedicalAssessor,
        Role.MedicalSpecialist,
        Role.Admin,
      ]) &&
        process.env.REACT_APP_CHAT_APP_URL && (
          <Button
            variant="outline-secondary"
            className="ms-1"
            onClick={nav.chats}
          >
            Podgląd badanych
          </Button>
        )}
    </>
  );
};
